import { render, staticRenderFns } from "./RegistrationLiveView.vue?vue&type=template&id=796cbcd3&"
import script from "./RegistrationLiveView.vue?vue&type=script&lang=ts&"
export * from "./RegistrationLiveView.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationLiveView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports